var logout = "https://shopfront-cdn.tekoapis.com/static/ab3ea40352f63ad2.svg";

export { logout as default };
